import { render } from "./mosaic_1.0.0.vue?vue&type=template&id=de83b218"
import script from "./mosaic_1.0.0.vue?vue&type=script&lang=ts"
export * from "./mosaic_1.0.0.vue?vue&type=script&lang=ts"
script.render = render

export default script